import { ANSWER_MESSAGE, OrdenExpressGetUserCredentials, OrdenExpressValidateSecurityForAnswer } from 'orden_express/frameWork/frameWork.js';
import { ofType } from 'redux-observable';
import { URL_SERVER } from 'routes.js';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';


const REQUEST_GET_REPORT_PRODUCTS_REQUESTED = 'REQUEST_GET_REPORT_PRODUCTS_REQUESTED';
export const requestGetReportProductsRequested = (dateOfDelivery) => (
  {
    type: REQUEST_GET_REPORT_PRODUCTS_REQUESTED,
    dateOfDelivery
  }
);

export const RESPONSE_GET_REPORT_PRODUCTS_REQUESTED = 'RESPONSE_GET_REPORT_PRODUCTS_REQUESTED';
const responseGetReportProductsRequested = responseGetReportProductsRequested => (
  {
    type: RESPONSE_GET_REPORT_PRODUCTS_REQUESTED,
    responseGetReportProductsRequested
  }
);

export const fromServerGetReportProductsRequested = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_REPORT_PRODUCTS_REQUESTED),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/reports/reportProducts', { parameterString1: action.dateOfDelivery }, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetReportProductsRequested(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseGetReportProductsRequested(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

const REQUEST_GET_REPORT_DASHBOARD = 'REQUEST_GET_REPORT_DASHBOARD';
export const requestGetReportDashboard = (requestGetReportDashboard) => (
  {
    type: REQUEST_GET_REPORT_DASHBOARD,
    requestGetReportDashboard
  }
);

export const RESPONSE_GET_REPORT_DASHBOARD = 'RESPONSE_GET_REPORT_DASHBOARD';
const responseGetReportDashboard = responseGetReportDashboard => (
  {
    type: RESPONSE_GET_REPORT_DASHBOARD,
    responseGetReportDashboard
  }
);

export const fromServerGetReportDashboard = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_REPORT_DASHBOARD),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/reports/reportDashboard', action.requestGetReportDashboard, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetReportDashboard(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseGetReportDashboard(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);


const REQUEST_GET_REPORT_HISTORY_CLIENT = 'REQUEST_GET_REPORT_HISTORY_CLIENT';
export const requestGetReportHistoryClient = (requestGetReportHistoryClient) => (
  {
    type: REQUEST_GET_REPORT_HISTORY_CLIENT,
    requestGetReportHistoryClient
  }
);

export const RESPONSE_GET_REPORT_HISTORY_CLIENT = 'RESPONSE_GET_REPORT_HISTORY_CLIENT';
const responseGetReportHistoryClient = responseGetReportHistoryClient => (
  {
    type: RESPONSE_GET_REPORT_HISTORY_CLIENT,
    responseGetReportHistoryClient
  }
);

export const fromServerGetReportHistoryClient = (action$, state$) => action$.pipe(
  ofType(REQUEST_GET_REPORT_HISTORY_CLIENT),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/reports/reportHistoryClient', action.requestGetReportHistoryClient, OrdenExpressGetUserCredentials(state$.value)).pipe(
      map(response => responseGetReportHistoryClient(OrdenExpressValidateSecurityForAnswer(response.response))),
      catchError(error => of(responseGetReportHistoryClient(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export const REQUEST_RESET_STATE_REPORTS = 'REQUEST_RESET_STATE_REPORTS';
export const requestResetStateReports = () => (
  {
    type: REQUEST_RESET_STATE_REPORTS
  }
);

export default this;